import React from 'react';
import { DeleteRounded } from "@mui/icons-material";
import Button from "@common/Button";

const LessonPlannerContentCard = ({ title, onDelete }) => {
    return (
        <div className="ch-lesson-planner-content-card-wrapper">
            <div className="ch-lesson-planner-content-card">
                <span className="ch-lesson-planner-content-card-title">{title}</span>
            </div>
            <Button type="text" className="ch-lesson-planner-content-card-delete-btn" aria-label={`Remove ${title}`} onClick={onDelete}>
                <DeleteRounded style={{ fontSize: '18px' }} />
            </Button>
        </div>
    );
};

export default LessonPlannerContentCard;
